import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAt, faCalendarAlt, faHashtag, faSave, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        customer_id: '',
        customer_name: '',
        customer_address: '',
        customer_phone: '',
        quotation_date: '',
        due_date: '',
        details: '',
        customers: [],
        errors: [],
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = (e) => {
        e.preventDefault();
        const { customer_id, quotation_date, due_date, details } = this.state;
        var errors = [];
        if (!customer_id) { errors.push("error_customer_id"); }
        if (!quotation_date) { errors.push("error_quotation_date"); }
        if (!due_date) { errors.push("error_due_date"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            customer_id: customer_id,
            quotation_date: quotation_date,
            due_date: due_date,
            details: details,
            user_id: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("quotations/register", data)
            .then((dataResult) => {
                console.log(dataResult)
                var status = dataResult.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (dataResult.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Quotations!',
                        dataResult.data.msj,
                        'success'
                    )
                    this.props.history.push("/UpQuotations/" + dataResult.data.ID_QUOTATION);
                } else {
                    Swal.close();
                    Swal.fire(
                        'Quotations!',
                        dataResult.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    selectCustomer = (customer_id, customer_name, customer_address, customer_phone) => {
        this.setState({
            customer_id: customer_id,
            customer_name: customer_name,
            customer_address: customer_address,
            customer_phone: customer_phone
        });
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("quotations/customers")
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    customers: dataResult.data
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { customer_id, customer_name, customer_address, customer_phone, quotation_date, due_date, details, customers } = this.state;
        return (
            <>
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    <b>NEW QUOTATION</b>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.sendData}>
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>QUOTATION INFORMATION</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-2">
                                                        <label htmlFor="quotation_id">Quotation ID.</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" name="quotation_id" id="quotation_id" 
                                                                className="form-control form-control-sm" placeholder="Quotation ID." aria-describedby="helpId"
                                                                onChange={this.changeValue} readOnly />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4"></div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="quotation_date">Quotation Date</label>
                                                        <div className={((this.errorVerify("error_quotation_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="quotation_date" id="quotation_date" value={quotation_date}
                                                                className={((this.errorVerify("error_quotation_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Quotation Date" aria-describedby="helpId"
                                                                onChange={this.changeValue}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please choose Quotation Date</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="due_date">Due Date</label>
                                                        <div className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="due_date" id="due_date" value={due_date}
                                                                className={((this.errorVerify("error_due_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Due Date" aria-describedby="helpId"
                                                                onChange={this.changeValue}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please choose Due Date</small>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <label htmlFor="quotation_status">Status</label>
                                                        <input style={{ textTransform: 'uppercase', color: "#FFFFFF", backgroundColor: "#00539B", fontWeight: "bold" }} type="text" name="quotation_status" id="quotation_status" value="IN PROCESS"
                                                            className="form-control form-control-sm text-center" placeholder="Status" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-12">
                                                        <label htmlFor="details">Other Comments</label>
                                                        <textarea style={{ resize: 'none', textTransform: 'uppercase' }}
                                                            className='form-control form-control-sm' id="details" name="details" rows='3' value={details}
                                                            onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>CUSTOMER INFORMATION</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-2'>
                                                        <label htmlFor="customer_id">Customer ID.</label>
                                                        <div className={((this.errorVerify("error_customer_id")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                            <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#CustomersModal" slot='end'>
                                                                <FontAwesomeIcon icon={faUsers} />
                                                            </button>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="customer_id" id="customer_id" value={customer_id} 
                                                                className={((this.errorVerify("error_customer_id")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Customer ID." aria-describedby="helpId"
                                                                onChange={this.changeValue} readOnly />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please choose Customer</small>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <label htmlFor="customer_name">Customer Name</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_name" id="customer_name" value={customer_name}
                                                            className="form-control form-control-sm" placeholder="Customer Name" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <label htmlFor="customer_address">Customer Address</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="customer_address" id="customer_address" value={customer_address}
                                                            className="form-control form-control-sm" placeholder="Customer Address" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="customer_phone">Customer Phone</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="customer_phone" id="customer_phone" value={customer_phone}
                                                                className="form-control form-control-sm" placeholder="Customer Phone" aria-describedby="helpId"
                                                                onChange={this.changeValue} readOnly />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Please enter Customer Phone</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row'>
                                            <div className='col-xl-12 text-center'>
                                                <div className="btn-group" role="group" aria-label="">
                                                    <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Save</button>&nbsp;&nbsp;
                                                    <Link className="btn btn-danger btn-sm" to={"/MasterQuotations"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="CustomersModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="CustomersModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="CustomersModalLabel">Customers</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CUSTOMER</th>
                                                    <th className="align-middle">ADDRESS</th>
                                                    <th className="align-middle">PHONE</th>
                                                    <th className="align-middle">CHOOSE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    customers.map((itemCustomers) => (
                                                        <tr key={itemCustomers.ID_CUSTOMER }>
                                                            <td>{itemCustomers.NAME}</td>
                                                            <td>{itemCustomers.ADDRESS}</td>
                                                            <td>{itemCustomers.PHONE}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectCustomer(
                                                                                itemCustomers.ID_CUSTOMER,
                                                                                itemCustomers.NAME,
                                                                                itemCustomers.ADDRESS,
                                                                                itemCustomers.PHONE
                                                                            )
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Crear;